<template>
<div class="chapter">
<div class="inner_page">
<p class="fm-head">CONTENTS</p>
<p class="toc1"><a href="#/Prologue">Prologue</a></p>
<p class="toc1"><a href="#/Chapter1#C1">1. Dead in the Water</a></p>
<p class="toc"><a href="#/Chapter2#C2">2. A Star Is Dead</a></p>
<p class="toc"><span href="#/Chapter3#C3" title="Link target outside of Sample">3. The Last Meal</span></p>
<p class="toc"><span href="#/Chapter4#C4" title="Link target outside of Sample">4. The Twelfth Apostle</span></p>
<p class="toc"><span href="#/Chapter5#C5" title="Link target outside of Sample">5. Hunting the Hunter</span></p>
<p class="toc"><span href="#/Chapter6#C6" title="Link target outside of Sample">6. The Wrong Air</span></p>
<p class="toc"><span href="#/Chapter7#C7" title="Link target outside of Sample">7. The Final Battle</span></p>
<p class="toc"><span href="#/Chapter8#C8" title="Link target outside of Sample">8. The Man in Blue</span></p>
<p class="toc"><span href="#/Chapter9#C9" title="Link target outside of Sample">9. All the Same</span></p>
<p class="toc"><span href="#/Chapter10#C10" title="Link target outside of Sample">10. To Spite His Face</span></p>
<p class="toc"><span href="#/Chapter11#C11" title="Link target outside of Sample">11. Bad Medicine</span></p>
<p class="toc"><span href="#/Chapter12#C12" title="Link target outside of Sample">12. Insult to Injury</span></p>
<p class="toc"><span href="#/Chapter13#C13" title="Link target outside of Sample">13. Deep Troubles</span></p>
<p class="toc"><span href="#/Chapter14#C14" title="Link target outside of Sample">14. The Arrests</span></p>
<p class="toc"><span href="#/Chapter15#C15" title="Link target outside of Sample">15. Dark History</span></p>
<p class="toc"><span href="#/Chapter16#C16" title="Link target outside of Sample">16. Killer’s Brew</span></p>
<p class="toc"><span href="#/Chapter17#C17" title="Link target outside of Sample">17. It’s All a Game</span></p>
<p class="toc"><span href="#/Chapter18#C18" title="Link target outside of Sample">18. The Road Killers</span></p>
<p class="toc"><span href="#/Chapter19#C19" title="Link target outside of Sample">19. Deadly Alliances</span></p>
<p class="toc"><span href="#/Chapter20#C20" title="Link target outside of Sample">20. Compare to Contrast</span></p>
<p class="toc"><span href="#/Chapter21#C21" title="Link target outside of Sample">21. All Over Again</span></p>
<p class="toc"><span href="#/Chapter22#C22" title="Link target outside of Sample">22. Sweet Sorrow</span></p>
<p class="toc"><span href="#/Chapter23#C23" title="Link target outside of Sample">23. Icarus of the Golden City</span></p>
<p class="toc"><span href="#/Chapter24#C24" title="Link target outside of Sample">24. A New Predator Stalks the Castro</span></p>
<p class="toc"><span href="#/Chapter25#C25" title="Link target outside of Sample">25. The Nice Guy</span></p>
<p class="toc"><span href="#/Chapter26#C26" title="Link target outside of Sample">26. The End of Two Eras</span></p>
<p class="toc"><span href="#/Chapter27#C27" title="Link target outside of Sample">27. On the Heels of Justice</span></p>
<p class="toc1"><span href="#/Acknowledgements" title="Link target outside of Sample">Acknowledgements</span></p>
<p class="toc"><span href="#/Bibliography" title="Link target outside of Sample">Bibliography</span></p>
<p class="toc"><span href="#/Author" title="Link target outside of Sample">About the Author</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Contents.vue?69d53f65